export default __webpack_public_path__ + "static/media/bugy.7519a02a.png";